module.exports = __webpack_public_path__ + "static/img/aika-matkakansi.bf61d8f.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aikamatka/aika-matkakansi.jpeg
// module id = TBjU
// module chunks = 1